export const getPaginationConfig = (totalRecords = 0) => {
  const baseOptions = [10, 20, 50, 100, 1000];

  //show all records when total record count > 1000
  const pageSizeOptions =
    totalRecords > 1000
      ? [...baseOptions, totalRecords]
      : baseOptions;

  return {
    defaultPageSize: 20,
    position: ['bottomCenter'],
    pageSizeOptions,
    showSizeChanger: true
  };
};